import React from 'react';
import { Box } from '@mui/material';
import { Header } from './Header';
import { SecurityAssistantSidebar } from '../SecurityAssistant/SecurityAssistantSidebar';

interface AppLayoutProps {
  children: React.ReactNode;
}

export const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
  // Sidebar collapsed state
  const [sidebarCollapsed, setSidebarCollapsed] = React.useState(false);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Header />
      <Box sx={{ display: 'flex', flexGrow: 1, overflow: 'hidden' }}>
        {/* Main content area - takes remaining space */}
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            bgcolor: 'background.default',
            overflow: 'auto',
            minWidth: 0, // Allows flex item to shrink below content size
          }}
        >
          {children}
        </Box>

        {/* Security Assistant Sidebar - fixed width, always visible */}
        <SecurityAssistantSidebar
          collapsed={sidebarCollapsed}
          onToggleCollapse={() => setSidebarCollapsed(!sidebarCollapsed)}
        />
      </Box>
    </Box>
  );
};
